export default __webpack_public_path__ + "static/media/3.60e7fc63.png";